var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRemoveicon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4592 17.9242C12.8835 17.9242 11.3431 17.457 10.033 16.5816C8.7228 15.7061 7.70165 14.4619 7.09864 13.0061C6.49564 11.5503 6.33787 9.9484 6.64527 8.40295C6.95268 6.85751 7.71147 5.43792 8.82567 4.32372C9.93988 3.20951 11.3595 2.45073 12.9049 2.14332C14.4504 1.83591 16.0523 1.99369 17.508 2.59669C18.9638 3.19969 20.2081 4.22084 21.0835 5.53101C21.9589 6.84118 22.4262 8.38151 22.4262 9.95724C22.4262 11.0035 22.2201 12.0395 21.8197 13.0061C21.4194 13.9727 20.8325 14.851 20.0927 15.5908C19.3529 16.3306 18.4746 16.9174 17.508 17.3178C16.5414 17.7182 15.5054 17.9242 14.4592 17.9242ZM14.4592 8.83124L12.2052 6.57824L11.0792 7.70424L13.3322 9.95824L11.0792 12.2112L12.2062 13.3382L14.4592 11.0852L16.7122 13.3382L17.8392 12.2112L15.5852 9.95824L17.8382 7.70524L16.7122 6.57824L14.4592 8.83124Z",
    fill: "#CC0000"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoveicon);
export default __webpack_public_path__ + "static/media/removeicon.de42b81e6b4333d22d2df4252245b9d6.svg";
export { ForwardRef as ReactComponent };